<div class="page-body">
  <div *ngIf="!trustlyUrl">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="trustlyUrl" class="contents-wrapper">
    <div class="contents-container">
      <iframe
        *ngIf="useIframe"
        id="frame"
        scrolling="yes"
        [src]="trustlyUrl"
      ></iframe>

      <div class="pr-info" *ngIf="amount && useIframe">
        <label>Totalbelopp</label>
        <label *ngIf="amount">
          {{
            amount.toLocaleString('sv', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
          }}
          {{ currencyCode }}
        </label>
      </div>
    </div>
  </div>
</div>


